export default __webpack_public_path__ + "static/media/error.de254730.gif";